export function eventToPropName(event: string): string {
    const normalizedEvent = event
        .split('-')
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join('');

    return `on${normalizedEvent}`;
}
